// extracted by mini-css-extract-plugin
export default {"btn_us":"QC","btn_us_active":"RC","btn_metric":"SC","btn_metric_active":"TC","metrics_btn_wrapper":"UC","btn_us_profile":"VC","btn_us_profile_active":"WC","btn_metric_profile":"XC","btn_metric_profile_active":"YC"};
    if(module.hot) {
      // 1737143661226
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  